import React, { useRef, useState } from 'react';
import QRCode from 'react-qr-code';
import html2canvas from 'html2canvas';
import './MemberCard.css';

export default function MemberCard({ member }) {
  const cardRef = useRef(null);
  const [profileImage, setProfileImage] = useState(null);
  const [imageUploaded, setImageUploaded] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(URL.createObjectURL(file));
      setImageUploaded(true);
    }
  };

  const handleDownload = () => {
    if (!imageUploaded) {
      alert('❗ Please upload a profile image before downloading the card.');
      return;
    }

    if (cardRef.current) {
      html2canvas(cardRef.current).then((canvas) => {
        const link = document.createElement('a');
        link.download = `${member.fullName}_ECard.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
      });
    }
  };

  return (
    <div className="ecard-wrapper">
      {/* Image Upload */}
      <div className="image-upload">
        <label><strong>Select Profile Image: </strong></label>
        <input type="file" accept="image/*" onChange={handleImageChange} />
      </div>

      {/* E-Card Preview */}
      <div className="ecard" ref={cardRef}>
        <div className="ecard-header">
          <img
            src={profileImage || "/placeholder-profile.png"}
            alt="Profile"
            className="ecard-image"
          />
          <h2 className="ecard-title">தமிழ்மணமலை அறக்கட்டளை</h2>
        </div>

        <div className="ecard-info">
          <p><strong>👤 Name:</strong> {member.fullName}</p>
          <p><strong>📧 Email:</strong> {member.email}</p>
          <p><strong>📞 Phone:</strong> {member.phone}</p>
          <p><strong>🏠 Address:</strong> {member.address}</p>
        </div>

        <div className="ecard-qr">
          <QRCode value={member.email || 'Tamilmanamalai'} size={90} />
        </div>

      <div className="ecard-signature">
  <img
    src="/sign2.png"
    alt="Signature"
    className="signature-image"
  />
  <p>Signed: Head of the Trustee</p>
</div>

      </div>

      <button
        className="ecard-download-btn"
        onClick={handleDownload}
        style={{ opacity: imageUploaded ? 1 : 0.5, cursor: imageUploaded ? 'pointer' : 'not-allowed' }}
      >
        Download E-Card
      </button>
    </div>
  );
}
